import React from 'react'

interface SourceTagProps {
  value: string
}

const SourceTag: React.FC<SourceTagProps> = ({ value }) => {
  return (
    <div
      style={{
        padding: '1px 3px',
        borderRadius: '5px',
        fontSize: '15px',
        color: '#222831',
      }}
    >
      {value}
    </div>
  )
}
export default SourceTag
